import React, { Component } from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import { SceneHeader, SceneDropDown, HeightDropDown } from "../../../_metronic/_partials/controls";
import SceneDropDownAction from '../../../_metronic/_partials/controls/SceneDropDownAction'
import { Row, Col, Accordion, Card, useAccordionButton } from 'react-bootstrap'
import { SubHeader } from "../../layout/components/subheader/SubHeader";
import SceneDragItem from './SceneDragItem';
import { layoutUpdate, UPDATE_SCENE_STATUS, UPDATE_STATUS, updateExpandedAccordion, sceneUpdateTitle, sceneUpdateHeight, CREATE_SCENE  } from '../../../../../../../actions/sceneActions'
import { secondsToTime, convertIntToBool, loaderCircleStyle, getPosition } from '../../../../../../../utils'
import { toAbsoluteUrl } from "../../../_metronic/_helpers/AssetsHelpers";
import SceneTitle from './SceneTitle';
import { MediaBaseUrl } from "../../../../../../../actions/api";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";

const circleStyle = loaderCircleStyle
 
function AccordionToggle({ children, eventKey,onClickFun, as }) {
    const decoratedOnClick = useAccordionButton(eventKey, onClickFun);
    return (
      <div className="accordion__ f-between p-3 w-100 show card-header" as={as} onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }

class Demo1Dashboard extends Component {
    state = {
        intial: 10,
        duration: secondsToTime(10),
        isFocused: false,
        defaultExpandedKey: "0",
        isScreeUpdate: false,
        showAcaord:false
    }

        
    onIncreaseTime = event => {
        const { intial } = this.state;
        this.setState({ intial: (intial + 1), duration: secondsToTime((intial + 1)) })
    }
    onDecreaseTime = event => {
        const { intial } = this.state;
        this.setState({ intial: (intial - 1), duration: secondsToTime((intial - 1)) })
    }
    onUpdateSceneStatus = (sceneContentId, status) => event => {
        this.props.UPDATE_SCENE_STATUS(sceneContentId, status);
    }
    onUpdateStatus = (status) => event => {
        const { match } = this.props;
        this.props.UPDATE_STATUS(status, match.params.wallId);
    }
    onExpandAccordion = (key) => event => {
        const { scenes } = this.props;
        this.props.updateExpandedAccordion(String(key))

    }
    onUpdateVisibleScreen = event => this.setState({ isScreeUpdate: true })
    onClickToHideSave = () =>{ 
        this.setState({ isScreeUpdate: false, })}

        onLoadCreateScene = (event) => {  
         
            const { layouts, wallStudio } = this.props;
            if (layouts && layouts.length > 0) {  
                const selectedLayout = layouts[0];
                if (selectedLayout && selectedLayout.id) {  
                    this.props.CREATE_SCENE(selectedLayout.id, wallStudio.wallID, () => { 
                    if (document.getElementById("kt_aside_menu")) {
                        var elmnt = document.getElementById("kt_aside_menu");
                        if (elmnt.scrollHeight) elmnt.scrollTo(0, elmnt.scrollHeight);
                      }
                    })
                 }
              }
            };


    render() {
        const { scenes, match, studio, history, layouts } = this.props;
        const { duration, isScreeUpdate } = this.state;
        const isActiveScene = (scenes.scenes && scenes.scenes[scenes.defaultScene]) ? scenes.scenes[scenes.defaultScene] : null;

        return (isActiveScene  ? 
        <div className="walls_screen">
           <SubHeader onUpdateStatus={this.onUpdateStatus} enableStudio={convertIntToBool(studio.is_studio_enabled)} wallID={match.params.wallId} />
           <div className="subheader_content">
                <div className="mb-3 container-fluid"> 
                    <SceneHeader icon="flaticon-warning font-primary" name={isActiveScene.name} key={uuidv4()}>  
                    <Row>
                            <Col className="justify-content-start d-flex">
                                <div className="d-flex align-items-center">
                                    <div className="screen_title d-flex position-relative pr-8">
                                        <h4 className="m-0 text-nowrap overflow-hidden">
                                            {
                                                isScreeUpdate ? <SceneTitle name={isActiveScene.name} sceneID={isActiveScene.id} sceneUpdateTitle={this.props.sceneUpdateTitle} css={isActiveScene.css} onClickToHideSave={this.onClickToHideSave} /> : isActiveScene.name
                                            }
                                        </h4>
                                        {!isScreeUpdate && <span className="active-btn-screen-title" onClick={this.onUpdateVisibleScreen}>
                                            <FontAwesomeIcon type={'regular'} icon={'pen-to-square'} iconClass={''} />
                                        </span>}
                                    </div>
                                    <SceneDropDown activeScene={scenes.scenes[scenes.defaultScene]} layoutUpdate={this.props.layoutUpdate} />
                                </div>
                            </Col>
                        <Col className="justify-content-center d-flex align-items-center">
                                <span className="label label-xxl label-inline label-dark-50 font-size-h5">{secondsToTime(isActiveScene.totalTime)}</span>
                            </Col>
                            <Col className="justify-content-end d-flex align-items-center">
                                <SceneDropDownAction circleStyle={circleStyle} onUpdateSceneStatus={this.onUpdateSceneStatus} status={isActiveScene.status} sceneContentId={isActiveScene.id} {...this.props} data={isActiveScene} />
                            </Col>
                        </Row>
                    </SceneHeader>
                </div>
                <div className="container-fluid">
                    <Accordion defaultActiveKey={scenes.defaultExpandedKey} className="card-header-acc">
                        {
                            scenes.scenes && scenes.scenes[scenes.defaultScene] && scenes.scenes[scenes.defaultScene].sceneContent && scenes.scenes[scenes.defaultScene].sceneContent.map((sceneCard, cIndex) => {
                                return scenes.scenes[scenes.defaultScene].mixContentType ? <Card key={cIndex}>

                                    <Card.Header>
                                        <Row className="m-0">
                                            <Col className="justify-content-start d-flex" md={10}>
                                                <AccordionToggle aria-controls="collapseExample" as={Card.Header} eventKey={`${cIndex}`} onClickFun={this.onExpandAccordion(cIndex)} className={`accordion__ d-flex align-items-center justify-content-between p-5 w-100 ${scenes.defaultExpandedKey == cIndex ? `show` : `hide`}`}>
                                                <div className="d-flex align-items-center main-txt">
                                                    <FontAwesomeIcon type={'regular'} icon={'angle-up'} iconClass={'me-2 fs-3'} />
                                                    <h6 className="mb-0">{sceneCard.name}</h6>
                                                    </div>
                                                </AccordionToggle>

                                            
                                            </Col>
                                            <Col className="justify-content-between d-flex align-items-center" md={2}>
                                                {isActiveScene && <HeightDropDown cssStyle={isActiveScene.css} sceneCard={sceneCard} position={getPosition(isActiveScene.partitions, sceneCard)} layouts={layouts} mixContentType={isActiveScene.mixContentType} activeID={isActiveScene.id} />}
                                                <span className="screen_count rounded-circle f-center">

                                                    {sceneCard.data.length}</span>
                                            </Col>
                                        </Row>
                                    </Card.Header>

                                    <Accordion.Collapse eventKey={`${cIndex}`} id="collapseExample">
                                        <Card.Body>
                                            <SceneDragItem key={cIndex} sceneID={scenes.scenes[scenes.defaultScene].id} data={sceneCard.data} onIncreaseTime={this.onIncreaseTime} onDecreaseTime={this.onDecreaseTime} duration={duration} match={match} history={history} />
                                            <div className="scene-card-body d-flex align-items-center justify-content-center">
                                                <div className="scene-options text-center">
                                                    <div className="scene-icon-list d-flex align-items-center flex-wrap justify-content-center">
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/wall/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                       <FontAwesomeIcon type={'solid'} icon={'tv'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">Display Wall</small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/media/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                        <FontAwesomeIcon type={'solid'} icon={'photo-film'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text"> Media</small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/links/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                        <FontAwesomeIcon type={'solid'} icon={'link'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">Link </small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/links/vimeo/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                        <FontAwesomeIcon type={'brands'} icon={'vimeo-v'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">Vimeo </small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/links/youtube/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                        <FontAwesomeIcon type={'brands'} icon={'youtube'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">YouTube </small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/apps/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                    <FontAwesomeIcon type={'solid'} icon={'grid-2-plus'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">Apps</small>
                                                                </div>
                                                            </Link>
                                                        </div>
                                                        <div className="scene-icon-action">
                                                            <Link className="d-flex align-items-center justify-content-center" to={`/studio/${match.params.wallId}/shorcode/${scenes.scenes[scenes.defaultScene].id}/${(cIndex + 1)}`}>
                                                                <div className="d-flex flex-column">
                                                                    <span className="code-svg-icon">
                                                                     <FontAwesomeIcon type={'solid'} icon={'code'} iconClass={'fs-2 text-dark'} />
                                                                    </span>
                                                                    <small className="scene-icon-action-text">Shortcode</small>
                                                                </div>
                                                            </Link>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card> : null
                            })

                        }


                    </Accordion>
                </div>
            </div>
        </div> 
           : 
        <div className="subheader_content">
            <div className="container-fluid">
                <div className="card card-custom">
                    <div className="card-body p-4">
                        <div className="table-scrollable globalTblList">
                            <div className="f-center flex-column text-center" style={{ minHeight: 'calc(100vh - 320px)' }}>
                                <img src={`${MediaBaseUrl}error/drop-box.svg`} className="img-fluid mb-4" style={{ width: '200px' }} />
                                <h5 className="mb-3">Oops! Nothing found</h5>
                                <div className="buttonUpgred mb-3">
                                <button onClick={this.onLoadCreateScene} to={`/studio/${match.params.wallId}/add/scene`} type="button" id="initCreateFeed" height={250} width={200} className="btn btn-primary">Add Scene</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        scenes: state.scene,
        studio: state.studio.studioWall,
        layouts: state.layout.layouts
    }
}
const mapDispatchToProps = dispatch => {
    return {
        layoutUpdate: (layoutID) => dispatch(layoutUpdate(layoutID)),
        UPDATE_STATUS: (status, wallId) => dispatch(UPDATE_STATUS(status, wallId)),
        UPDATE_SCENE_STATUS: (sceneContentId, status) => dispatch(UPDATE_SCENE_STATUS(sceneContentId, status)),
        updateExpandedAccordion: (key) => dispatch(updateExpandedAccordion(key)),
        sceneUpdateTitle: (sceneID, title, css, callBack) => dispatch(sceneUpdateTitle(sceneID, title, css, callBack)),
        sceneUpdateHeight: (sceneID, zoneID, height) => dispatch(sceneUpdateHeight(sceneID, zoneID, height)),
        CREATE_SCENE: (layoutID, wallId, callBack) =>  dispatch(CREATE_SCENE(layoutID, wallId, callBack)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Demo1Dashboard);